<div class="w-full min-h-screen flex flex-col bg-[#F7F9FF]">
  <app-header class="w-full h-fit"></app-header>

  <main
    class="flex-1 flex flex-col items-center pt-20 pb-10 gap-12 m-auto max-w-[1280px] min-[1024px]:items-start min-[1024px]:pb-1 min-[1024px]:gap-20 min-[1024px]:px-8"
  >
    <!-- Section - Hero: Who we Are -->
    <section
      id="who-we-are"
      class="flex flex-col items-start justify-start gap-[30.9px] px-6 pt-20 pb-10 w-full min-[1024px]:flex-row min-[1024px]:gap-0 min-[1024px]:px-0"
    >
      <!-- Left container (Pill + Heading) -->
      <div class="flex flex-col items-start justify-start w-full min-[1024px]:pb-8 gap-8">
        <app-pill class="w-fit h-fit"></app-pill>

        <div class="flex flex-col items-start justify-start w-full pb-[0.69px] min-[1024px]:pb-0">
          <span
            class="w-full text-[#161C23] font-bold text-5xl tracking-[-2.4px] leading-[52.8px] text-left min-[1024px]:text-8xl min-[1024px]:tracking-[-4.8px] min-[1024px]:leading-[96px]"
          >
            The Technical<br /><span class="text-[#71747C]">Atelier.</span>
          </span>
        </div>
      </div>

      <!-- Right container (Description text) -->
      <div
        class="flex flex-col items-start justify-start w-full min-[1024px]:items-center min-[1024px]:justify-center min-[1024px]:pt-[86.25px]"
      >
        <div
          class="flex flex-col items-start justify-center w-full min-[1024px]:w-[448px] min-[1024px]:max-w-[448px] min-[1024px]:pb-[0.75px]"
        >
          <p
            class="w-full text-[#474747] font-normal text-lg leading-[29.25px] tracking-normal text-left min-[1024px]:text-xl min-[1024px]:leading-[32.5px] min-[1024px]:h-[195px] min-[1024px]:w-[445px]"
          >
            We build digital products that create real value in the world. Not just features. Not
            just code. Solutions that actually matter. We work across multiple domains, including
            PropTech, HealthTech, Market and Business Intelligence, Sustainability Tech, and
            Manufacturing Tech, to name a few.
          </p>
        </div>
      </div>
    </section>

    <app-based class="w-full h-fit"></app-based>

    <app-office-situation id="office" class="w-full h-fit"></app-office-situation>

    <app-how-we-work id="day-to-day" class="w-full h-fit"></app-how-we-work>

    <app-technologies-we-use id="tech-stack" class="w-full h-fit"></app-technologies-we-use>

    <app-sharing-is-caring id="culture" class="w-full h-fit"></app-sharing-is-caring>

    <app-want-to-join id="join-us" class="w-full h-fit"></app-want-to-join>

    <app-show-your-skills class="w-full h-fit"></app-show-your-skills>
  </main>

  <app-footer class="w-full h-fit"></app-footer>
</div>
